    function removeAssemblyProductsFromCart(e){
        var target = e.target,
           getParentId = target.getAttribute('data-parent-id'),
           getLineItemId = target.getAttribute('data-line-id');
           document.querySelectorAll('.CartItem__Remove.Link.Link--underline.Link--underlineShort').forEach(function(element, index){
                var elementParentId = element.getAttribute('data-parent-id'),
                    elementLineItemId = element.getAttribute('data-line-id'),
                    elementAssemblyId = element.getAttribute('data-assembly-id');
                    if(elementParentId == getParentId && 
                        getLineItemId !== elementLineItemId && 
                        elementAssemblyId !== undefined){
                             // window.location.href = '/cart/change?quantity=0&id=' + getLineItemId + '&id=' + elementLineItemIds
                             // // window.location.href = '/cart/change?quantity=0
                            //  var currentUrl = window.location.href;
                            //  target.click()
                            //  setTimeout(function(){
                            //  element.click()
                            // }, 300)
                            // window.location.replace(currentUrl);
                    }
        });
    }

    document.addEventListener('click', function(e){
        if(e.target.classList.contains('icon') || 
           e.target.classList.contains('CartItem__Remove') ){
             removeAssemblyProductsFromCart(e);
        }
    });
